import { render, staticRenderFns } from "./inventory-product-search.vue?vue&type=template&id=4cab05f8&"
import script from "./inventory-product-search.vue?vue&type=script&lang=js&"
export * from "./inventory-product-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports